import { IAction, IState } from '../initialValues'

export const photoCaptureReducer = (state: IState, action: IAction): IState => {
    const actionHandlers: {
        [key: string]: (state: IState, payload: any) => IState
    } = {
        SET_IMAGE_SOURCE: (state, payload) => ({
            ...state,
            photo: payload,
        }),
        SET_IS_LOADING: (state, payload) => ({
            ...state,
            isUploading: payload,
        }),
        ERROR: (state, payload) => ({
            ...state,
            error: payload,
        }),
    }

    const handler = actionHandlers[action.type]
    return handler ? handler(state, action.payload) : state
}
